import { Component, OnInit, Input } from "@angular/core";
import { KickbackReportResult } from "../models/kickback.model";

@Component({
  selector: "wego-kickback-data-grid",
  template: require('../views/kickback-data-grid.component.html'),
  styles:[
    `
      .level-1 {
        padding-left: 15px;
      }
      .level-2 {
        padding-left: 45px;
      }
      .level-3 {
        padding-left: 75px;
      }
      .level-4 {
        padding-left: 105px;
      }
      .level-5 {
        padding-left: 135px;
      }
      .level-6 {
        padding-left: 165px;
      }
      .border-kickback-data-grid {
        border: 1px solid #E0E0E0;
        border-top: none;
        padding: 5px 0px;
      }
    `    
  ]
})
export class KickbackDataGridComponent implements OnInit {
  @Input("Data") data: KickbackReportResult[];

  constructor() {}

  ngOnInit() {}

  public GetLabelName(groupName: string) {
    switch (groupName) {
      case "INSTANCE":
        return "LblInstance";
      case "COMPANY":
        return "LblCompany";
      case "VEHICLE":
        return "LblVehicle";
      case "SVG":
        return "LblSVG";
      case "ORGANIZATION":
        return "LblOrganization";
      case "CTG":
        return "LblContractTypeGroup";
    }
  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/report/components/kickback-data-grid.component.ts